import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';
import { CreateCodeConductRequest } from '../models';

@Injectable()
export class XpressCodeConductService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getCodeConducts(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminCodeConduct/GetCodeConducts', data, messageService);
    }

    public createCodeConduct(request: CreateCodeConductRequest, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminCodeConduct/CreateCodeConduct', request, messageService);
    }
}
